import { TerramapContext } from "../context"
import { State } from "../state"
import { SetParametersFooter } from "./parameters/SetParametersFooter"

interface Props {
    state: State
}

export function Footer({ state }: Props) {

    const components: { [key in State["type"]]: React.FunctionComponent<Props> } = {

        "init": Index,
        "index": Index,

        "setParameters": SetParametersFooter

    }

    const Component = components[state.type]

    return <div className="footer">
        <Component state={state} />
    </div>

}

function Index() {

    const { dispatch, close, api } = React.useContext(TerramapContext)

    const setParameters = () => dispatch({ type: "startSetParameters" })

    const refreshAndClose = async () => {
        await api.refresh()
        close()
    }

    return <>

        <div className="left">
            <button type="button" className="btn btn-link" onClick={() => setParameters()}>
                <i className="fas fa-pen" />Edit parameters
            </button>
        </div>

        <div className="actions">
            <button type="button" className="btn btn-warning" onClick={refreshAndClose}>
                Close
            </button>
        </div>

    </>

}
